import React, { useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import quicktixlogo from "../../../Images/GX_Logo_Black_No_Bg.png";
import { Input, notification } from "antd";
import { useForgotPasswordMutation } from "../../../Redux/Slices/Accounts/AccountsapiSlice";
import { useNavigate } from "react-router-dom";
import QuickTixLogo from "../../../Images/GX_Logo_White_No_Bg.png";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [forgotPassword, { isLoading, isSuccess, isError, error }] =
    useForgotPasswordMutation();
  const navigate = useNavigate();
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (!validateEmail(newEmail)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleSendResetEmail = async () => {
    if (emailError) {
      notification.error({
        
        message: emailError,
      });
      return;
    }

    try {
      const response = await forgotPassword(email).unwrap();
      if (response.success) {
        notification.success({
          
          message: "OTP code sent successfully!",
        });
        navigate(`/verify-account?email=${encodeURIComponent(email)}`);
      }
    } catch (err) {
      console.error("Failed to send OTP code: ", err);
      notification.error({
        
        message: "Failed to send OTP code!",
      });
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "black",
          width: "100%",
          height: "80px", // Adjust height as needed
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed", // Use 'fixed' if you want it to stay on scroll
          top: 0,
          left: 0,
        }}
        textAlign="center"
      >
        <img
          src={QuickTixLogo}
          alt="GX Tickets"
          style={{ height: "75px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
      </Box>

      <Grid p={5}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={11} md={6} lg={4}>
            <Box
              textAlign="justify"
              hyphens={"auto"}
              display={"flex"}
              flexDirection={"column"}
              gap={2}
              pt={15}
            >
              <Typography variant="h4" sx={{ textAlign: "center", mb: 2}}>Forgot Password</Typography>
              {/* <Typography variant="body1" gutterBottom>
                Enter the code to verify your account
              </Typography> */}
              <Typography variant="body2" gutterBottom>
                Please enter your email address to receive a code for resetting your password.
              </Typography>

              <Box sx={{ textAlign: "left" }}>
                <Typography
                  sx={{ fontWeight: 500, fontSize: 14,  }}
                >
                  Email
                </Typography>
                <Input
                  placeholder="Enter Your Email"
                  size="large"
                  inputMode="email"
                  value={email}
                  onChange={handleEmailChange}
                />
                {emailError && (
                  <Typography variant="body2" color="red">
                    {emailError}
                  </Typography>
                )}
              </Box>

              <Button
                variant="outlined"
                sx={{
                  mt: 2,
                  width: "100%",
                  textTransform: "none",
                  backgroundColor: "var(--primary-color)",
                  borderRadius: 20,
                  color: "white",
                  outline: "none",
                  border: "none",
                  "&:hover": {
                    color: "grey",
                    border: "1px solid black",
                    outline: "none",
                  },
                }}
                onClick={handleSendResetEmail}
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Send Reset Email"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ForgetPassword;
